import React from 'react'
import AbsencePlannerDrawer from 'components/AbsencePlannerDrawer'
import type { AbsenceRequestConflictsT, PersonT } from 'types'
import AbsenceRequestConflicts from '../absence-request-conflicts'
import type { AbsenceRequestConflictsCardProps } from './types'
import { useAbsenceRequestConflictCard } from './use-absence-request-conflict-cards'

const AbsenceRequestConflictsCard = (props: AbsenceRequestConflictsCardProps) => {
  const {
    startDate,
    endDate,
    showAbsencePlannerPreview = false,
    previewPerson,
    showAbsencePlannerDrawer = false,
    setShowAbsencePlannerDrawer,
  } = props
  const { conflicts, loading, handleClick } = useAbsenceRequestConflictCard(props)

  if (loading || !conflicts) return null

  return (
    <>
      {showAbsencePlannerPreview && (
        <AbsencePlannerDrawer
          isOpen={showAbsencePlannerDrawer}
          onCancel={() => setShowAbsencePlannerDrawer(false)}
          previewPerson={previewPerson as PersonT}
          startDate={startDate}
          endDate={endDate}
        />
      )}
      <AbsenceRequestConflicts conflicts={conflicts as AbsenceRequestConflictsT} onClick={handleClick} />
    </>
  )
}

export default AbsenceRequestConflictsCard
